export default {
  section3Title: {
    id: 'insurance_modal_section_3_title',
    defaultMessage: 'Frequently Asked Questions',
  },
  infoQuestion1: {
    id: 'insurance_modal_infos_question_1',
    defaultMessage: 'What is exactly covered?',
  },
  infoResponse1: {
    id: 'insurance_modal_infos_response_1',
    defaultMessage:
      'With the damage pack, you get a protection against any type of breakage (phone drop, assault, water on the phone etc). With the Damage & Theft pack, you get the same protection with the theft included.',
  },
  infoQuestion2: {
    id: 'insurance_modal_infos_question_2',
    defaultMessage:
      'What are the perks of the popular plan and the fully loaded plan?',
  },
  infoResponse2: {
    id: 'insurance_modal_infos_response_2',
    defaultMessage:
      'We offer more than a simple insurance. Your device is covered against damage and theft even in case of negligence. On top of that, you benefit from extras such as a free ecological case and screen protector and a discount if, at some point, you want to replace your battery with a new one. Also, for every insurance plan sold we give a donation of 1€ to a charity called Wings of the Ocean. This 1€ covers their cost to clean the equivalent of 1 square meter of ocean!',
  },
  infoQuestion3: {
    id: 'insurance_modal_infos_question_3',
    defaultMessage: 'What is excluded from the insurance plans?',
  },
  infoResponse3: {
    id: 'insurance_modal_infos_response_3',
    defaultMessage:
      "Everyone feels like they're getting fleeced when choosing insurance, so we decided to do things a little differently. Our plans do what they say on the box, and they include negligence which is often excluded from standard plans. There are still basic exclusions though (fault must not be intentional, the device has to be used by the insuree, theft is covered but not loss, etc.). Check out the Insurance Product Information Document for full details and don't hesitate to contact us if you have any questions!",
  },
}
